export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/containers/index.ts